import { useMutation, useQuery, UseMutationOptions, UseMutationResult, UseQueryOptions } from '@tanstack/react-query'
import {
  getFuzzyInfoService,
  getUserInfoService,
  getVerifyCodeService,
  loginService,
  TGetFuzzyInfoServiceParams,
  TGetVerifyCodeServiceParams,
  TVerifyImage4LoginServiceParams,
  verifyImage4LoginService,
  getOneTradeInfo,
  TGetOneTradeInfoParams,
  getFullDepth,
  TGetFullDepthParams,
  TGetFullDepthResponse,
  TGetCoinInfoParams,
  TGetCoinInfoResponse,
  getCoinInfo,
  TGetUserInfoServiceResponse,
} from 'core/service/hk-web/api'
import {
  getSecretKeyService,
  TLoginServiceParams,
  TGetSecretKeyParams,
  TGetFuzzyInfoServiceResponse,
  TGetVerifyCodeServiceResponse,
  TGetOneTradeInfoResponse,
} from '../../service/hk-web/api'
import { TUseQueryOptions } from '../type'
import { AxiosResponse } from 'axios'
import { TResponse } from '../../service/hcResponse'

export const useGetFuzzyInfoMutation = (
  mutationOptions?: UseMutationOptions<AxiosResponse<TGetFuzzyInfoServiceResponse>, Error, TGetFuzzyInfoServiceParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['getFuzzyInfoService'],
    mutationFn: (data: TGetFuzzyInfoServiceParams) => {
      return getFuzzyInfoService(data)
    },
  })
}

export const useGetFuzzyInfoQuery = (data: TGetFuzzyInfoServiceParams) => {
  return useQuery({
    queryKey: ['getFuzzyInfoService'],
    queryFn: () => getFuzzyInfoService(data),
  })
}

export const useGetVerifyCodeMutation = (
  mutationOptions?: UseMutationOptions<AxiosResponse<TGetVerifyCodeServiceResponse>, Error, TGetVerifyCodeServiceParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['getVerifyCode'],
    mutationFn: (params: TGetVerifyCodeServiceParams) => getVerifyCodeService(params),
  })
}

export const useLoginMutation = () => {
  return useMutation({
    mutationKey: ['common', 'auth', 'login'],
    mutationFn: (data: TLoginServiceParams) => {
      return loginService(data)
    },
  })
}

export const useVerifyImage4LoginMutation = () => {
  return useMutation({
    mutationKey: ['common', 'auth', 'verifyImage4Login'],
    mutationFn: (data: TVerifyImage4LoginServiceParams) => {
      return verifyImage4LoginService(data)
    },
  })
}

export const useSecretKeyMutation = () => {
  return useMutation({
    mutationKey: ['common', 'secretKey'],
    mutationFn: (params: TGetSecretKeyParams) => {
      return getSecretKeyService(params)
    },
  })
}

export const useGetUserInfoQuery = (options?: TUseQueryOptions<TResponse<TGetUserInfoServiceResponse>>) => {
  return useQuery({
    ...options,
    queryKey: ['getUserInfoService'],
    queryFn: () => getUserInfoService(),
  })
}

export const useGetOneTradeInfoQuery = (
  params: TGetOneTradeInfoParams,
  options?: TUseQueryOptions<TResponse<TGetOneTradeInfoResponse>>
) => {
  return useQuery({
    ...options,
    queryKey: ['getOneTradeInfo', ...Object.values(params)],
    queryFn: () => getOneTradeInfo(params),
  })
}

export const useGetFullDepthQuery = (
  params: TGetFullDepthParams,
  options?: TUseQueryOptions<TGetFullDepthResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['getFullDepth', ...Object.values(params)],
    queryFn: () => getFullDepth(params),
  })
}

export const useGetCoinInfoQuery = (params: TGetCoinInfoParams, options?: TUseQueryOptions<TGetCoinInfoResponse>) => {
  return useQuery({
    ...options,
    queryKey: ['getCoinInfo', ...Object.values(params)],
    queryFn: () => getCoinInfo(params),
  })
}
